<template>
  <article tabindex="0">
    <section 
      v-for="section in sections"
      :key="section.id"
      tabindex="0"
    >
      <vue3-markdown-it
        v-bind="$mdOpts"
        :source="processImages(section.Contents)"
        tabindex="0"
      ></vue3-markdown-it> 
    </section>
  </article>
</template>

<script>
import strapi from '../../utils/strapi'

export default {
  name: "Article",
  props: ["sections"],
  mounted() {
    this.handleLinks()
  },
  methods: { 
    ...strapi,
    handleLinks() {
      setTimeout(() =>{
        Array
        .from(document.querySelectorAll(`section a`))
        .forEach(a => {
          const href = a.attributes.href.value
          if (href && (href.startsWith('/') || href.startsWith(this.$appURL))) {
            a.addEventListener('click', (e) => {
              this.$router.push(
                href.replace(
                  this.$appURL, '/'
                )
              )
              e.preventDefault()
            })
          }
        })
      }, 500)
    }
  }
}
</script>

<style >



article {
  max-width: 40em;
  padding: 0 1em;
  z-index: 1;
  overflow: scroll;

  /* text-shadow: 0 0px 4px var(--light1); */
}

article p a {
  word-break: break-all;
}

.mobile article {
  max-width: 100%;
}

.mobile article p a {
  /* word-break: break-all; */
}


</style>
